<header>
  <ts-nav-bar [hidden]="(showHeader$ | async) === false" [isDevVersion]="isDevBuild" [sidenav]="snav"
    [showLogo]="showLogo$ | async"></ts-nav-bar>
</header>

<mat-sidenav-container style="flex-grow: 1; display: flex; flex-direction: column">
  <mat-sidenav #snav mode="over" position="end" style="left: 10%" [class.main-div-mt]="showHeader$ | async"
    fixedTopGap="56">
    <ts-side-nav *ngIf="snav.opened"></ts-side-nav>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content" style="flex-grow: 1; display: flex; flex-direction: column">
    <div id="main-div" [class.main-div-mt]="showHeader$ | async" [class.watermarked]="isDevBuild">
      <div class="router-outlet-flex-host">
        <router-outlet (activate)="snav.close()"></router-outlet>
      </div>
      <div class="chat-container">
        <ts-chat-icon *ngIf="(showChatIcon$ | async) === true" (click)="showChatBox(true)"></ts-chat-icon>
        <ts-chat-box *ngIf="(showChatBox$ | async) === true" (showChatBoxChanged)="showChatBox($event)"></ts-chat-box>
      </div>
      <footer>
        <ts-footer id="footer" [hidden]="(showFooter$ | async) === false"></ts-footer>
      </footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
